var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('div',{staticClass:"main-preload"},[_c('div',{staticClass:"main-preload__content"},[_c('terms-of-use-page',{on:{"submit":_vm.onSubmit}})],1),_c('div',{staticClass:"terms-of-use-modal__sidebar"},[_c('img',{attrs:{"src":require("@/assets/img/accept-docs.svg"),"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }